import { render } from "./Trust.vue?vue&type=template&id=3f460fae&scoped=true"
import script from "./Trust.vue?vue&type=script&lang=js"
export * from "./Trust.vue?vue&type=script&lang=js"

import "./Trust.vue?vue&type=style&index=0&id=3f460fae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f460fae"]])

export default __exports__